<template>
  <div
    class="modal fade"
    id="editAgency"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <!-- Close button in the upper right corner -->
          <button
            type="button"
            class="close"
            aria-hidden="true"
            @click="toggleDialog(false)"
          >
            ×
          </button>

          <!-- Modal Title -->
          <h4 class="modal-title">
            <b>{{ modeAdd ? lang.AM3000 : lang.AM3001 }}</b>
          </h4>
        </div>
        <!-- Modal Body -->
        <div class="modal-body" v-if="!loading">
          <div
            class="panel-group"
            id="accordion"
            role="tablist"
            aria-multiselectable="true"
          >
            <div class="panel panel-default">
              <div
                class="panel-heading"
                role="button"
                id="headingGeneral"
                data-toggle="collapse"
                data-parent="#accordion"
                href="#collapseGeneral"
                aria-expanded="true"
                aria-controls="collapseGeneral"
              >
                <h4 class="panel-title">
                  <a class="collapsed">{{ lang.AM3002 }}</a>
                </h4>
              </div>
              <div
                id="collapseGeneral"
                class="panel-collapse collapse in"
                role="tabpanel"
                aria-labelledby="headingGeneral"
              >
                <div class="panel-body">
                  <div class="form-group">
                    <label for="inputAgencyName" class="col-md-2 control-label"
                      >{{ lang.AM3003 }}*</label
                    >
                    <div class="col-md-10">
                      <input
                        type="text"
                        class="form-control"
                        id="inputAgencyName"
                        name="inputAgencyName"
                        v-model="agencyEditModel.AgencyName"
                        @keyup="validateInput('inputAgencyName')"
                        required
                      />
                      <span
                        v-show="inputHasError('inputAgencyName')"
                        class="help-block error text-danger"
                        >{{ lang.AM3014 }}</span
                      >
                    </div>
                  </div>

                  <div
                    class="form-group"
                    v-if="
                      feature.isAudiTarget &&
                      feature.isEnabled('leadAgencies') &&
                      !globals.isAgencyUser
                    "
                  >
                    <label class="col-md-2 control-label">{{
                      lang.AM3015
                    }}</label>
                    <div class="col-md-10 text-left">
                      <div
                        class="radio"
                        v-for="type in agencyTypeList"
                        :key="type.AgencyTypeGuid"
                      >
                        <label>
                          <input
                            type="radio"
                            name="editAgencyTypeRadios"
                            v-model="agencyEditModel.AgencyTypeGuid"
                            :value="type.AgencyTypeGuid"
                            :disabled="
                              globals.currentUserInfo.AgencyGuid ===
                              agencyEditModel.AgencyGuid
                            "
                          />
                          <span class="text text-primary">{{
                            type.AgencyTypeName
                          }}</span>
                          <span class="circle"></span>
                          <span class="check"></span>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div
                    class="form-group"
                    v-if="
                      feature.isAudiTarget &&
                      feature.isEnabled('leadAgencies') &&
                      agencyEditModel.AgencyTypeGuid === localAgencyTypeGuid
                    "
                  >
                    <label
                      for="editAgencyParentSelect"
                      class="col-md-2 control-label"
                      >{{ lang.AM3016 }}*</label
                    >
                    <div class="col-md-10">
                      <select2
                        class="form-control"
                        id="editAgencyParentSelect"
                        :disabled="
                          globals.currentUserInfo.AgencyGuid ===
                            agencyEditModel.AgencyGuid || globals.isAgencyUser
                        "
                        v-model="agencyEditModel.ParentAgency"
                        required
                      >
                        <option
                          v-for="agency in leadAgencyList"
                          :key="agency.AgencyGuid"
                          :value="agency.AgencyGuid"
                        >
                          {{ agency.AgencyName }}
                        </option>
                      </select2>
                    </div>
                  </div>

                  <div class="form-group">
                    <label
                      for="inputAgencyStreet"
                      class="col-md-2 control-label"
                      >{{ lang.AM3004 }}</label
                    >
                    <div class="col-md-10">
                      <input
                        type="text"
                        class="form-control"
                        id="inputAgencyStreet"
                        name="inputAgencyStreet"
                        v-model="agencyEditModel.AgencyAddress"
                      />
                    </div>
                  </div>

                  <div class="form-group">
                    <label
                      for="inputAgencyStreet2"
                      class="col-md-2 control-label"
                      >{{ lang.AM3012 }}</label
                    >
                    <div class="col-md-10">
                      <input
                        type="text"
                        class="form-control"
                        id="inputAgencyStreet2"
                        name="inputAgencyStreet2"
                        v-model="agencyEditModel.AgencyAddress2"
                      />
                    </div>
                  </div>

                  <div class="form-group">
                    <label
                      for="inputAgencyCity"
                      class="col-md-2 control-label"
                      >{{ lang.AM3005 }}</label
                    >
                    <div class="col-md-10">
                      <input
                        type="text"
                        class="form-control"
                        id="inputAgencyCity"
                        name="inputAgencyCity"
                        v-model="agencyEditModel.AgencyCity"
                      />
                    </div>
                  </div>

                  <div class="form-group">
                    <label
                      for="inputAgencyZip"
                      class="col-md-2 control-label"
                      >{{ lang.AM3006 }}</label
                    >
                    <div class="col-md-10">
                      <input
                        type="text"
                        class="form-control"
                        id="inputAgencyZip"
                        name="inputAgencyZip"
                        v-model="agencyEditModel.AgencyPostalCode"
                      />
                    </div>
                  </div>

                  <div class="form-group">
                    <label
                      for="editAgencyCountrySelect"
                      class="col-md-2 control-label"
                      >{{ lang.AM3007 }}*</label
                    >
                    <div class="col-md-10">
                      <select2
                        class="form-control"
                        id="editAgencyCountrySelect"
                        :afterChange="
                          (d) => {
                            countryChanged(true);
                          }
                        "
                        v-model="agencyEditModel.AgencyCountry"
                        :placeholder="lang.AM3013"
                        :allowClear="true"
                        required
                      >
                        <option
                          v-for="(country, ISOCode) in globals.countryList"
                          :key="ISOCode"
                          :value="ISOCode"
                        >
                          {{ country }}
                        </option>
                      </select2>
                    </div>
                  </div>

                  <div class="form-group">
                    <label
                      for="editAgencyRegionSelect"
                      class="col-md-2 control-label"
                      >{{ lang.AM3011 }}*</label
                    >
                    <div class="col-md-10">
                      <select2
                        class="form-control"
                        id="editAgencyRegionSelect"
                        ref="editAgencyRegionSelect"
                        :key="agencyEditModel.AgencyCountry"
                        :disabled="
                          !agencyEditModel.AgencyCountry ||
                          regionsOfCountry.length < 1
                        "
                        v-model="agencyEditModel.RegionGuid"
                        :placeholder="lang.AM3013"
                        :allowClear="true"
                        required
                      >
                        <option
                          v-for="region in regionsOfCountry"
                          :key="region.RegionGuid"
                          :value="region.RegionGuid"
                        >
                          {{ region.RegionName }}
                        </option>
                      </select2>
                    </div>
                  </div>

                  <div class="form-group">
                    <label
                      for="inputAgencySince"
                      class="col-md-2 control-label"
                      >{{ lang.AM3008 }}</label
                    >
                    <div
                      class="col-md-10"
                      @click="globals.toggleFlatpickr('inputAgencySince')"
                    >
                      <input
                        type="date"
                        class="form-control"
                        id="inputAgencySince"
                        name="inputAgencySince"
                        v-model="agencyEditModel.AgencySince"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-raised btn-default"
            @click="toggleDialog(false)"
          >
            {{ lang.AM3009 }}
          </button>
          <button
            id="agency-management-edit-modal-save-button"
            type="button"
            class="btn btn-raised dialog-btn-primary"
            @click="validateBeforeSubmit('editAgency')"
            :disabled="!globals.isAccessAllowed('LoopOp_Agencies_Update')"
          >
            {{ lang.AM3010 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "../Tools/Select2";

export default {
  name: "AgencyManagementEditModal",
  components: { Select2 },
  props: [
    "showEditModal",
    "modeAdd",
    "editAgencyModel",
    "allRegions",
    "agencyList",
  ],
  mounted() {
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
      this.globals.getCountryList();
    }

    this.fpAgencySince = flatpickr(
      "#inputAgencySince",
      this.globals.flatpickrDateConfig
    );

    this.globals.getAgencyTypeList((data) => {
      this.agencyTypeList = data;
      let localAgency = _.find(this.agencyTypeList, (at) => {
        return at.AgencyTypeName === "Local";
      });
      this.localAgencyTypeGuid = localAgency ? localAgency.AgencyTypeGuid : "";
    });
  },
  destroyed() {
    if (this.fpAgencySince) this.fpAgencySince.destroy();
  },
  data() {
    return {
      lang: {
        AM3000: "Neue Agentur anlegen",
        AM3001: "Agentur bearbeiten",
        AM3002: "Stammdaten",
        AM3003: "Name",
        AM3004: "Straße",
        AM3005: "Stadt",
        AM3006: "PLZ",
        AM3007: "Land",
        AM3008: "Agentur seit",
        AM3009: "Abbrechen",
        AM3010: "Speichern",
        AM3011: "Region",
        AM3012: "Adresszusatz",
        AM3013: "Bitte auswählen...",
        AM3014: "Diese Angabe ist erforderlich!",
        AM3015: "Agency type",
        AM3016: "Lead agency",
      },
      agencyEditModel: {
        AgencyId: "",
        AgencyGuid: "",
        AgencyName: "",
        AgencyTypeGuid: "",
        AgencyAddress: "",
        AgencyAddress2: "",
        AgencyCity: "",
        AgencyPostalCode: "",
        AgencyCountry: "",
        AgencyState_Region: "",
        AgencySince: "",
      },
      showMe: false,
      loading: false,
      regionsOfCountry: [],
      invalidInputIds: [],
      fpAgencySince: null,
      agencyTypeList: [],
      localAgencyTypeGuid: "",
    };
  },
  computed: {
    leadAgencyList() {
      return this.agencyList.filter((ag) => {
        return (
          ag.AgencyTypeGuid !== this.localAgencyTypeGuid &&
          ag.AgencyGuid !== this.agencyEditModel.AgencyGuid
        );
      });
    },
  },
  methods: {
    // Validates an input with the given id, changes the input color depending on the validation result and returns the result
    validateInput(id) {
      var result = $("#" + id)[0].checkValidity(); // Checks validation depending on the input type or a given pattern in the template
      if (result) {
        $("#" + id)
          .parent()
          .parent()
          .removeClass("has-error"); // has-error has to be added to the form-group element
        var idx = this.invalidInputIds.indexOf(id);
        if (idx > -1) {
          this.invalidInputIds.splice(idx, 1); // Remove from list, if valid
        }
      } else {
        $("#" + id)
          .parent()
          .parent()
          .addClass("has-error");
        if (this.invalidInputIds.indexOf(id) < 0) this.invalidInputIds.push(id); // Add to list, if invalid
      }
      return result;
    },

    // Returns true if an input has a validation error, otherwise false
    inputHasError(id) {
      if (this.invalidInputIds.indexOf(id) > -1) return true;
      return false;
    },

    // Triggers input validation and ensures further progress if validation was successful
    validateBeforeSubmit(dialogId) {
      var result = true;

      var elements = $("#" + dialogId).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0)
          result = this.validateInput(elements[i].id) && result; // If only one input is invalid, the whole form is invalid
      }

      if (dialogId == "editAgency") {
        if (!result) {
          this.globals.showErrorSnackbar("Form validation failed");
          return;
        }
        this.emitNewAgency();
      }
    },

    // Resets all validation errors for the given dialog
    resetValidationErrors(dialogId) {
      var elements = $("#" + dialogId).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0)
          $("#" + elements[i].id)
            .parent()
            .parent()
            .removeClass("has-error");
      }
      this.invalidInputIds = [];
    },

    toggleDialog(show) {
      if (show === false) {
        this.showMe = show;
      }

      if (this.showMe) {
        $("#editAgency").modal("show");
        if (this.modeAdd) {
          this.prepareNew();
        } else this.getAgencyEditModel();
        if (!this.agencyEditModel.AgencyCountry) this.countryChanged(true);
      } else {
        $("#editAgency").modal("hide");
        this.$emit("modalClosed", true);
      }
    },

    prepareNew() {
      this.loading = true;
      this.agencyEditModel = {};
      if (this.localAgencyTypeGuid)
        this.$set(
          this.agencyEditModel,
          "AgencyTypeGuid",
          this.localAgencyTypeGuid
        );

      if (this.globals.currentUserInfo.AgencyGuid) {
        let myAgency = _.find(
          this.leadAgencyList,
          (a) =>
            a.AgencyGuid ===
            this.globals.currentUserInfo.AgencyGuid.toUpperCase()
        );
        if (myAgency) this.agencyEditModel.ParentAgency = myAgency.AgencyGuid;
      }
      this.fpAgencySince.clear();
      this.$nextTick(() => {
        this.resetValidationErrors("editAgency");
        this.loading = false;
      });
    },

    getAgencyEditModel() {
      this.loading = true;
      $.ajax({
        method: "GET",
        url: `api/agencies/${this.editAgencyModel.AgencyGuid}`,
        success: (data) => {
          if (data.Error) {
            this.globals.showErrorSnackbar(data.Error);
            return;
          }

          if (data.ParentAgencies) {
            data.ParentAgency = data.ParentAgencies[0].AgencyGuid;
            delete data.ParentAgencies;
          }
          this.agencyEditModel = data;
          this.countryChanged();
          this.fpAgencySince.setDate(
            this.agencyEditModel.AgencySince,
            true,
            "Y-m-d"
          );
          this.$nextTick(() => {
            this.resetValidationErrors("editAgency");
          });
        },
        error: () => {
          console.error("Agency data access failed in getAgencyEditModel()");
          this.globals.showErrorSnackbar("Agency data access failed");
        },
        complete: () => {
          this.loading = false;
        },
      });
    },

    // Emit methods
    emitNewAgency() {
      let saveData = _.cloneDeep(this.agencyEditModel);

      if (saveData.AgencyTypeGuid !== this.localAgencyTypeGuid)
        delete saveData.ParentAgency;

      if (saveData.ParentAgency) {
        saveData.ParentAgencies = [{ AgencyGuid: saveData.ParentAgency }];
        delete saveData.ParentAgency;
      }

      this.$emit("onAgencySaved", saveData);
      this.toggleDialog(false);
    },
    countryChanged(resetRegionModel) {
      this.regionsOfCountry = [];
      const country = this.agencyEditModel.AgencyCountry;
      if (!this.allRegions) return;

      if (country) {
        let filteredRegions = this.allRegions.filter(
          (r) => r.CountryCode.toLowerCase().indexOf(country.toLowerCase()) >= 0
        );

        if (filteredRegions.length > 0) {
          this.regionsOfCountry = filteredRegions[0].Regions;
          //this.$refs.editAgencyRegionSelect.reinit();
        }
      }

      if (!country || resetRegionModel) delete this.agencyEditModel.RegionGuid;
    },
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
      this.globals.getCountryList();
    },
    showEditModal(newVal) {
      this.showMe = newVal;
      if (newVal) this.toggleDialog();
    },
  },
};
</script>

<style scoped>
.radio {
  display: inline-block;
  margin-right: 20px;
  height: 25px;
}
.radio .text {
  position: relative;
  left: -10px;
  top: 0px;
}
</style>



// WEBPACK FOOTER //
// AgencyManagementEditModal.vue?0e9b5554